import { CustomerProfileResponse } from '@porterin/booking-flow/src/auth/domain/api-models/CustomerProfileApiModel';
import { CustomerProfile } from '@porterin/booking-flow/src/auth/domain/entities/CustomerProfile';

const toCustomerProfileEntity = (
  api: CustomerProfileResponse,
): CustomerProfile => {
  return {
    mobile: api.mobile,
    customerUuid: api.external_id,
    firstName: api.first_name ?? '',
    lastName: api.last_name ?? '',
    mailInfo: {
      isVerified: api.mail_info.is_verified ?? false,
      email: api.mail_info.email ?? '',
    },
  };
};

export { toCustomerProfileEntity };
